import OutlinedFlagIcon from "@mui/icons-material/OutlinedFlag";
import { Box } from "@mui/material";
import DataTable from "app/components/DataTable";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { adminPriceTableRow } from "../../types";
import { useStyles } from "./styles";

type Props = {
  rows: adminPriceTableRow[] ;
  loading?: boolean;
};

const AdminPriceTable = ({ rows, loading = false }: Props) => {
  const { t } = useTranslation();
  const styles = useStyles();



  const columns = useMemo(
    () => [
      {
        id: "lastUpdatedAt",
        label: t("ADMIN_PRICE.TABLE.LAST_UPDATE"),
        minWidth: 120,
        align: "right",
      },
      {
        id: "basePrice",
        label: t("ADMIN_PRICE.TABLE.BASE_PRICE"),
        minWidth: 100,
        align: "right",
      },
      {
        id: "unit",
        label: t("ADMIN_PRICE.TABLE.UNIT_OF_MEASURE"),
        minWidth: 120,
        align: "right",
      },
      {
        id: "itemName",
        label: t("ADMIN_PRICE.TABLE.PRODUCT_NAME"),
        minWidth: 100,
        align: "right",
      },
      {
        id: "category",
        label: t("ADMIN_PRICE.TABLE.CATEGORY"),
        minWidth: 120,
        align: "right",
      },
    ],
    [styles, t]
  );

  return (
    <div className={styles.root} dir="ltr">
      <DataTable
        rows={rows || []}
        columns={columns}
        loading={loading}
        serialEnabled={false}
        isPointerCursor
      />
    </div>
  );
};

export default AdminPriceTable;
